import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router'
import { DEFAULT_META, getCustomMeta } from 'config/constants/meta'
import Container from './Container'
import Header from './Header'

const StyledPage = styled.div`
  width: 100%;
  min-height: 100vh;
  // min-height: calc(100vh - ${({theme})=>theme.config.nav.heightMb});
  // ${({ theme }) => theme.mediaQueries.sm} {
  //   min-height: calc(100vh - ${({theme})=>theme.config.nav.heightPc});
  // }
`

const PageMeta = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const cakePriceUsdDisplay =  ''

  const pageMeta = getCustomMeta(pathname, t) || {}
  const { title, description, image } = { ...DEFAULT_META, ...pageMeta }
  const pageTitle = cakePriceUsdDisplay ? [title, cakePriceUsdDisplay].join(' - ') : title

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
    </Helmet>
  )
}

const Page: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  return (
    <>
      <PageMeta />
      <Header />
      <StyledPage {...props}>{children}</StyledPage>
    </>
  )
}

export default Page
